import { BaseDataService, BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { List } from "immutable";

export class SpisakDokumenataV2 extends BaseEntity{

    constructor(
        // private baseDataService: BaseDataService
    ){
        super();
    }
    ID: number;
    MasterDokumID: number; 
    Broj: string;
    Datum: NgbDate;    
    Ukupno: number;
    VezaDokID: number;
    ObjekatID: number;
    ObjekatNaziv: string;
    GenericName: string;
    Istekao: boolean;
    Details: SpisakDokumenataStavkeV2[] = null;
    // IsExpand: boolean = false;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Checked = input.Checked;
        this.MasterDokumID = input.MasterDokumID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.Ukupno = input.Ukupno;
        this.VezaDokID = input.VezaDokID;
        this.ObjekatID = input.ObjekatID;
        this.ObjekatNaziv = input.ObjekatNaziv;
        this.GenericName = input.GenericName;
        this.Istekao = input.Istekao;
        this.Details = [];
        //ovde obraditi ako je Checked da vrati iz veza_dok_stav
        //ili da vrati stavke od avansa ako nema ništa u veza_dok_stav
       
        // if (input.Details!=null){            
        //     input.Details.forEach(Item => {
        //         return this.Details.push(new SpisakDokumenataStavkeV2().Deserialize(Item))
        //     });    
        // }
        // else
        //     this.Details=[];
        // this.IsExpand = input.IsExpand;
        return this;
    }

    Serialize(input: SpisakDokumenataV2){
        return input;
    }

    GetInstance(){
        return this;
    }
}

export class SpisakDokumenataStavkeV2 extends BaseEntity{
    constructor(){
        super();
    }
    // ID: number;
    // VezaDokID: number;
    Opis: string;
    TarifaID: number;
    Stopa: number;
    UkIznos: number;
    IskoriscenIznos: number;
    Iznos: number;
    Ostalo: number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Opis = input.Opis;
        this.TarifaID = input.TarifaID;
        this.Stopa = input.Stopa;
        this.UkIznos = input.UkIznos;
        this.IskoriscenIznos = input.IskoriscenIznos;
        this.Iznos = input.Iznos;
        this.Ostalo = input.Ostalo;
        return this;
    }

    Serialize(input: SpisakDokumenataStavkeV2){
        return input;
    }
}